import { createSelector } from '@reduxjs/toolkit';
import { getFromImmutableState } from 'src/utils/immutableUtils';

export const _getHotelsList = (state) => state.getIn(['hotels', 'hotels']);

export const getHotelsIds = createSelector(_getHotelsList, (hotels) =>
  hotels.map((hotelItem) => hotelItem.getIn(['hotel', 'id'])),
);

export const getHotelsSurchargesByLevel = createSelector(
  _getHotelsList,
  (hotels) => hotels.map((hotelItem) => hotelItem.get('surcharges_by_level')),
);

export const getHotelsAccommodationAvailability = createSelector(
  _getHotelsList,
  (hotels) => hotels.map((hotel) => hotel.getIn(['availability', 'hotel'])),
);

export const getHotelsFlightSeats = createSelector(_getHotelsList, (hotels) =>
  hotels.map((hotel) => hotel.getIn(['availability', 'flight'])),
);

export const getHotelsTourIds = createSelector(_getHotelsList, (hotels) =>
  hotels.map((hotel) => hotel.get('tour_id')),
);
export const getHotelsList = getFromImmutableState(_getHotelsList);
export const _getFilteredHotelsList = (state) =>
  state.getIn(['hotels', 'filtered_hotels']);
export const getFilteredHotelsList = getFromImmutableState(
  _getFilteredHotelsList,
);

export const _getCurrentVisibleHotels = (state) =>
  state.getIn(['hotels', 'currentVisibleHotels']);

export const getCurrentVisibleHotels = getFromImmutableState(
  _getCurrentVisibleHotels,
);

export const getHotelsToShow = (state) =>
  state.getIn(['hotels', 'hotelsToShow']);
export const getHotelsCount = (state) => state.getIn(['hotels', 'hotelsCount']);

export const getCurrentPage = (state) => state.getIn(['hotels', 'currentPage']);
export const getAwaitingPagination = (state) =>
  state.getIn(['hotels', 'awaitingPagination']);

export const getHasHotels = createSelector(
  getHotelsList,
  (hotels) => hotels?.length > 0 || false,
);

export const getHasHotelFilteredHotels = createSelector(
  [getHotelsList, getFilteredHotelsList],
  (hotels, filtered_hotels) => !hotels?.length && !filtered_hotels?.length,
);

export const latestVisibleHotelSelector = createSelector(
  getCurrentVisibleHotels,
  (visibleHotels) => (visibleHotels.length ? Math.max(...visibleHotels) : null),
);

export const getHotelById = (state, id) => {
  const index = _getHotelsList(state).findIndex(
    (item) => item.getIn(['hotel', 'id']) === id,
  );
  return _getHotelsList(state).get(index);
};

export const getFallbackSearch = (state) =>
  state.getIn(['hotels', 'fallbackSearch']);

const _getNearestDepartures = (state) =>
  state.getIn(['hotels', 'nearestDepartures']);

export const getNearestDepartures = getFromImmutableState(
  _getNearestDepartures,
);

const _getNearestDates = (state) => state.getIn(['hotels', 'nearestDates']);

export const getNearestDates = getFromImmutableState(_getNearestDates);

export const getPageLimit = (state) => state.getIn(['hotels', 'pageLimit']);

export const getLiveSearchAllowed = (state) =>
  state.getIn(['hotels', 'liveSearchAllowed']);
